// src/routes.js
const ROUTES = {
  HOME: "/",
  IMAGE_CONVERT: "/image-converter",
  CONVERT_TO_PNG: "/convert-to/png",
  CONVERT_TO_JPG: "/convert-to/jpg",
  CONVERT_TO_WEBP: "/convert-to/webp",
  CONVERT_TO_AVIF: "/convert-to/avif",
  CONVERT_TO_PDF: "/convert-to/pdf",
  CONVERT_TO_SVG: "/convert-to/svg",
  IMAGE_COMPRESSOR: "/image-compressor-online",
  // FILE_CONVERT: "/convert-files-to-pdf-online",
  PASSWORD_REMOVER: "/remove-password-from-pdf-or-zip",
  PASSWORD_SETTER: "/set-password-on-pdf-or-zip",
  IMAGE_RESIZE: "/resize-image-dimensions",
  IMAGE_RESIZE_CUSTOM: "/image-custom-size",
  MERGE_PDF: "/merge-pdf-files",
  SPLIT_PDF: "/split-pdf-pages",
  ROTATE_PDF: "/rotate-pdf-pages",
  DELETE_PDF: "/delete-pages-from-pdf",
  REORDER_PDF: "/reorder-pdf-pages",
  CROP_IMAGE: "/crop-image-online",
  IMAGE_TO_Word: "/image-to-word-converter-online",
  IMAGE_TO_Excel: "/image-to-excel-converter-online",
  PDF_TO_Word: "/pdf-to-word-converter-online",
  PDF_TO_Excel: "/pdf-to-excel-converter-online",
  Favicon_Text_Generator:"/text-to-favicon-generator",
  Favicon_Generator:"/png-to-favicon-generator",
  // WPS_TO_WORD:"/wps-to-word-converter",
  // WPS_TO_DOC:"/wps-to-doc-converter",
  // WPS_TO_PDF:"/wps-to-pdf-converter",
  // DA_CHECKER:"/da-checker",
  FILE_EXAMPLES:"/file-examples",
  ABOUT:"/about",
};

export default ROUTES;

